<template>
  <article v-if="highlight" class="flex flex-col">
    <h1
      class="mb-[28px] text-[32px] font-medium leading-[38px] xl:w-3/4 2xl:w-4/5"
      v-text="highlight?.title"
    />
    <div class="mb-[100px] flex gap-[20px]">
      <div class="flex flex-col xl:w-3/4 2xl:w-4/5">
        <CommonBlocksImageArticleBlock
          v-if="highlight?.image"
          class="mb-[32px]"
          is-social
          :data="highlight"
          :published-at="highlight?.published_at"
          :src="highlight.image.src"
        />
        <div class="page-body mb-4" v-html="highlight?.announce" />
      </div>
      <CommonBlocksBannersBlock
        v-if="bannerAd"
        class="hidden xl:grid xl:w-1/4 2xl:w-1/5"
        :data="bannerAd"
      />
      <CommonBlocksRightArticleBlock
        v-else
        class="xl:w-1/4 2xl:w-1/5"
        articles-per-page="2"
        video-per-page="1"
      />
    </div>
    <CommonTabs
      class="mb-8 w-full lg:w-fit"
      :list="contentTypes"
      is-collection
      :initial-tab-index="activeTabIndex"
    />
    <ClientOnly>
      <div v-if="itemBySlug?.data?.value?.length" class="mb-[100px]">
        <div class="-m-2.5 flex flex-wrap">
          <MainPageCardsReworkedBaseCard
            v-for="(collect, index) in itemBySlug?.data?.value"
            :key="`article-${collect.id}-${index}`"
            class="w-full max-w-[100%] p-2.5 sm:max-w-[50%] xl:max-w-[33.33333%]"
            :data="collect"
            disable-announce
          />
        </div>
      </div>
      <div
        v-else
        class="my-12 text-center font-roboto text-[32px] font-medium leading-[38px] text-new-gray-lighter"
      >
        В данной категории пока нет материалов
      </div>
    </ClientOnly>
    <CommonBlocksPageFooterBlocks />
  </article>
</template>

<script setup>
import bannerAd from '~/assets/data/banner-ad';
definePageMeta({
  layout: 'marginless',
});

const route = useRoute();
const slug = route?.params?.slug;
const { collectionSlug } = useCollectionSlug(slug);
const highlight = computed(() => collectionSlug?.data?.value?.highlight);

const getModelType = (modelType) => {
  let itemModel = '';
  switch (modelType) {
    case 'audiolecture':
    case 'audiomaterial':
      itemModel = 'audiomaterial';
      break;
    case 'videolecture':
    case 'videomaterial':
      itemModel = 'videomaterial';
      break;
    default:
      itemModel = modelType;
      break;
  }
  return itemModel;
};

const activeTabIndex = computed(() => {
  const idx = highlight.value?.content_types?.findIndex(
    ({ model }) => model === getModelType(route.query.content),
  );
  if (idx !== -1) return idx;
  const availableIdx = highlight.value?.content_types?.findIndex(
    ({ count }) => count > 0,
  );
  if (availableIdx !== -1) return availableIdx;
  return 0;
});

const model = computed(
  () => highlight.value?.content_types?.[activeTabIndex.value]?.model,
);
const { itemBySlug } = useCollectionItemBySlug(slug, model);

const contentTypes = computed(() =>
  highlight.value?.content_types.filter(
    ({ model }) => !['presentation'].includes(model),
  ),
);

useHead(
  computed(() => ({
    title: `${
      highlight.value ? highlight.value?.title + ' |' : ''
    } Подборки материалов по истории РФ для школьников и студентов`,
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: `${
          highlight.value ? highlight.value?.title + ' .' : ''
        } Подборки материалов по истории РФ для школьников и студентов на сайте Федерального портала истории России.`,
      },
      {
        hid: 'keywords',
        name: 'keywords',
        content: `${highlight.value?.title ?? highlight.value?.title}`,
      },
    ],
  })),
);
</script>

<style lang="scss"></style>
